<template>
    <div class="model-detail-container" v-if="currentList.length > 0">
        <div class="model-detail-header">
            <router-link :to="backUrl" class="logo hide-model"><img src="/images/logo-black.svg"></router-link>
        </div>
        <div class="model-detail-body">
            <div class="detailglide glide">
                <div class="wrapper model-detail-nav">
                    <router-link :to="backUrl"  class="btn-close-preview"></router-link>
                    <div class="glide__arrows" data-glide-el="controls">
                        <router-link v-if="prevModel" :to="{name: 'model', params: {id: prevModel.ID_Model, dir:'prev'}}" class="btn-prev-model">&lt; {{ trans('talents.profile.previous_model') }}</router-link>
                        <router-link v-if="nextModel" :to="{name: 'model', params: { id: nextModel.ID_Model,dir:'next'}}" class="btn-next-model">{{ trans('talents.profile.next_model') }} &gt;</router-link>
                    </div>
                </div>
                <div class="glide-container">
                    <div class="glide__track" data-glide-el="track">
                        <ul class="glide__slides">
                            <li class="glide__slide" v-for="(model, i) in currentList" :key="model.id">
                                <model v-show="open" :index="i" :list-name="listName"></model>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script type='text/babel'>
    import {mapState} from 'vuex'
    import Glide from '@glidejs/glide'
    import Model from './Model.vue'

    export default {
        components: {
            Model,
        },
        props: ['id'],
        data: function () {
            return {
                listName: 'models',
                currentId: false,
                newId: false,
                open: false
            }
        },
        beforeDestroy() {
            this.open = false
            console.log(this.open)
        },
        mounted() {
            setTimeout(function(){
                this.open = true

            }.bind(this),900)
            this.currentId = this.id
            if(this.mode === 'favorite') {
                document.getElementById('models-detail-overlay').classList.add('favorites')
            }
            else {
                document.getElementById('models-detail-overlay').classList.remove('favorites')
            }
            setTimeout(function(){
                this.glide = new Glide('.detailglide', {type: 'slider', startAt: this.index, animationDuration: 900}).mount()
            }.bind(this), 900)
        },
        computed: {
            ...mapState(['models']),
            ...mapState(['favorites']),
            ...mapState(['project']),
            applicationId() {
                return this.$store.getters.applicationId()
            },
            proposalId() {
                return this.$store.getters.proposalId()
            },
            backUrl() {
                return  this.applicationId && this.proposalId ? '/aanvraag/'+this.applicationId+'/'+this.proposalId : '/'
            },
            index() {
                return _.findIndex(this.currentList, {'ID_Model': this.currentId});
            },
            prevModel() {
                return this.currentList[this.index - 1]
            },
            nextModel() {
                return this.currentList[this.index + 1]
            },
            currentList() {
                return this.mode === 'favorites' ? this.favorites[this.project] : this.models //ADD IF IS THEN FAVORITES
            },
            mode(){
                return this.$store.getters.mode()
            },
        },
        watch: {
            '$route'(to, from) {
                if (to) {
                    this.currentId = to.params.id
                    this.glide.go('=' + this.index)
                }
            },
        },
        methods: {
        },
    };
</script>
